<template>
  <div v-loading="loading">
    <div class="wel_bg1">
      <img src="../static/1/wel_1.png" />
    </div>

    <div class="wel_bg1 wel_bg2" style="text-align: center; color: #fff">
      <div class="btn" @click="connectWallet">
        {{ lang.Login }}
      </div>
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="
            font-size: 30px;
            font-weight: 600;
            padding: 20px 0;
            padding-top: 70px;
          "
        >
          IG178.com
        </div>
        <div style="font-size: 20px">{{ lang.Favorite }}</div>
        <div style="font-size: 30px; font-weight: 600; padding: 10px 0">
          {{ lang.CryptoExchange }}
        </div>
        <div>{{ lang.Beginner }}</div>
      </div>
    </div>
    <!-- <div class="wel_bg3">
      <img src="@/static/1/wel_3.png" mode="scaleToFill" />
    </div> -->

    <div class="wel_bg4">
      <div class="wel_bg4_title">{{ lang.WhyChoose }} Ig178?</div>
      <div
        class="wel_bg4_item"
        v-for="(item, index) in wel_bg4_list"
        :key="item.title"
        :style="index % 2 == 1 ? 'background: #183351; ' : ''"
      >
        <div>
          <img src="@/assets/1.png" v-if="index == 0" mode="scaleToFill" />
          <img src="@/assets/2.png" v-if="index == 1" mode="scaleToFill" />
          <img src="@/assets/3.png" v-if="index == 2" mode="scaleToFill" />
          <img src="@/assets/4.png" v-if="index == 3" mode="scaleToFill" />
          <img src="@/assets/5.png" v-if="index == 4" mode="scaleToFill" />
          <img src="@/assets/6.png" v-if="index == 5" mode="scaleToFill" />
          <img src="@/assets/7.png" v-if="index == 6" mode="scaleToFill" />
        </div>
        <div>
          <div class="wel_bg4_item_title">{{ item.title }}</div>
          <div class="wel_bg4_item_content">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
    <div class="wel_bg5">
      <div class="wel5_bg_title">{{ lang.Exchange }}:</div>
      <div class="wel5_bg_title">{{ lang.Contender }}</div>
      <div class="wel5_bg_subtitle">{{ lang.countries }}</div>
      <div class="wel5_bg_flex">
        <div>
          <div class="wel5_bg_subtitle">{{ lang.dau }}</div>
          <div class="wel5_bg_title">5000 +</div>
        </div>
        <div>
          <div class="wel5_bg_subtitle">{{ lang.Registered }}</div>
          <div class="wel5_bg_title">300 K+</div>
        </div>
      </div>
      <div class="wel5_bg_flex">
        <div>
          <div class="wel5_bg_subtitle">{{ lang.DailyVolume }}</div>
          <div class="wel5_bg_title">2100 M+</div>
          <div style="font-size: 16px; color: #d8d8d8; text-align: center">
            USD
          </div>
        </div>
        <div>
          <div class="wel5_bg_subtitle">{{ lang.RegisteredUsers }}</div>
          <div class="wel5_bg_title">2000 M+</div>
          <div style="font-size: 16px; color: #d8d8d8; text-align: center">
            USD
          </div>
        </div>
      </div>
    </div>

    <div class="wel_bg6">
      <div class="wel6_bg_title">{{ lang.About }}</div>
      <div class="wel6_bg_subtitle">{{ lang.Bridging }}</div>
      <div class="wel6_bg_content">
        {{ lang.prioritize }}
      </div>

      <div class="wel6_team">
        <div class="wel6_team_title">{{ lang.OurTeam }}</div>
        <div class="wel6_team_flex">
          <div class="wel6_team_flex_box">
            <img src="@/static/1/robot1.png" mode="" />
            <div class="robot_title">{{ lang.Matt }}</div>
            <div class="robot_subtitle">{{ lang.ChiefArchitect }}</div>
          </div>
          <div class="wel6_team_flex_box">
            <img src="@/static/1/robot2.png" mode="" />
            <div class="robot_title">{{ lang.Jasper }}</div>
            <div class="robot_subtitle">{{ lang.TeamAdvocate }}</div>
          </div>
          <div class="wel6_team_flex_box">
            <img src="@/static/1/robot3.png" mode="" />
            <div class="robot_title">{{ lang.Jack }}</div>
            <div class="robot_subtitle">{{ lang.PlatformAlchemist }}</div>
          </div>
          <div class="wel6_team_flex_box">
            <img src="@/static/1/robot4.png" mode="" />
            <div class="robot_title">{{ lang.Ann }}</div>
            <div class="robot_subtitle">{{ lang.MarketingWiz }}</div>
          </div>
          <div class="wel6_team_flex_box">
            <img src="@/static/1/robot5.png" mode="" />
            <div class="robot_title">{{ lang.David }}</div>
            <div class="robot_subtitle">{{ lang.OPSNinja }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="wel_bg7">
      <div class="wel7_bg_title">{{ lang.OurPartners }}</div>
      <div class="wel7_bg_subtitle">
        {{ lang.recognized }}
      </div>
      <div class="wel7_bg_flex">
        <img src="@/static/1/our1.png" mode="" />
        <img src="@/static/1/our2.png" mode="" />
        <img src="@/static/1/our3.png" mode="" />
        <img src="@/static/1/our4.png" mode="" />
        <img src="@/static/1/our5.png" mode="" />
        <img src="@/static/1/our6.png" mode="" />
        <img src="@/static/1/our7.png" mode="" />
        <img src="@/static/1/our8.png" mode="" />
        <img src="@/static/1/our9.png" mode="" />
        <img src="@/static/1/our10.png" mode="" />
        <img src="@/static/1/our11.png" mode="" />
        <img src="@/static/1/our12.png" mode="" />
      </div>
    </div>

    <div class="wel_bg8">
      <div class="wel8_bg_title">{{ lang.Community }}</div>
      <div class="wel8_bg_flex">
        <div class="wel8_bg_flex_box">
          <img src="@/static/1/Telegram.png" mode="" />
          <text>{{ lang.Telegram }}</text>
        </div>
        <div class="wel8_bg_flex_box">
          <img src="@/static/1/Twitter.png" mode="" />
          <text>{{ lang.Twitter }}</text>
        </div>
        <div class="wel8_bg_flex_box">
          <img src="@/static/1/Reddit.png" mode="" />
          <text>Reddit</text>
        </div>
        <div class="wel8_bg_flex_box">
          <img src="@/static/1/Instagram.png" mode="" />
          <text>Instagram</text>
        </div>
        <div class="wel8_bg_flex_box">
          <img src="@/static/1/Facebook.png" mode="" />
          <text>Facebook</text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { createAppKit } from "@reown/appkit/react";
// import { mainnet } from "@reown/appkit/networks"; //arbitrum, mainnet
// import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { ethers } from "ethers";
import axios from "axios";
//import { config } from "@/config/index.js";
import zh from "@/locales/zh.json";
import en from "@/locales/en.json";
import ja from "@/locales/ja.json";
import ftchinese from "@/locales/ftchinese.json";
import hanwen from "@/locales/hanwen.json";
import putaoya from "@/locales/putaoya.json";
import yidali from "@/locales/yidali.json";
import taiwen from "@/locales/taiwen.json";
import yinni from "@/locales/yinni.json";
import yuenan from "@/locales/yuenan.json";
import fayu from "@/locales/fayu.json";
import { modal } from "@/config/appkit.js";
// 1. 从 https://cloud.walletconnect.com 获取你的 Project ID
// const projectId = config.projectId;
// // 3. 配置 Metadata
// const metadata = config.metadata;

// const modal = createAppKit({
//   adapters: [new EthersAdapter()],
//   networks: [mainnet],
//   metadata,
//   projectId,
//   features: {
//     enableAnalytics: true,
//     onramp: false,
//     socials: false,
//     email: false,
//   },
//   wel_bg4_list:[]
// });

//connectAndUseWallet();
export default {
  name: "LoginPage",

  data() {
    return {
      lang: {},
      address: null, // 初始化 address
      isConnected: false, // 初始化 isConnected
      buyerAddressForDeduction: null,
      isLoading: false,
      outputDetails: [],
      inviteCode: null,
      loading: false,
    };
  },
  components: {},

  methods: {
    getLanguage(lang) {
      //this.browserLang = navigator.language || navigator.userLanguage;

      if (lang.startsWith("Chinese")) {
        this.lang = zh;
      } else if (lang.startsWith("English")) {
        this.lang = en;
      } else if (lang.startsWith("Japan")) {
        this.lang = ja;
      } else if (lang.startsWith("ftchinese")) {
        this.lang = ftchinese;
      } else if (lang.startsWith("hanwen")) {
        this.lang = hanwen;
      } else if (lang.startsWith("putaoya")) {
        this.lang = putaoya;
      } else if (lang.startsWith("yidali")) {
        this.lang = yidali;
      } else if (lang.startsWith("taiwen")) {
        this.lang = taiwen;
      } else if (lang.startsWith("yinni")) {
        this.lang = yinni;
      } else if (lang.startsWith("yuenan")) {
        this.lang = yuenan;
      } else if (lang.startsWith("fayu")) {
        this.lang = fayu;
      }

      this.wel_bg4_list = [
        {
          icon: "@/assets/1.png",
          title: this.lang.Diverse,
          content: this.lang.flexibility,
        },
        {
          title: this.lang.Charts,
          content: this.lang.Optimize,
        },
        {
          title: this.lang.APR,
          content: this.lang.Enhance,
        },
        {
          title: this.lang.Premium,
          content: this.lang.Automatically,
        },
        {
          title: this.lang.Secure,
          content: this.lang.Experience,
        },
        {
          title: this.lang.Explore,
          content: this.lang.integrated,
        },
        {
          title: this.lang.Compliance,
          content: this.lang.licensed,
        },
      ];
    },
    changeLanguage(lang) {
      this.lang = lang;
    },
    formatDecimal(num) {
      const parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    generateEthereumWallet() {
      // 使用 ethers.js 生成随机钱包
      const wallet = ethers.Wallet.createRandom();
      // 返回钱包信息
      return {
        address: wallet.address,
        privateKey: wallet.privateKey,
      };
    },
    formatAddress(address) {
      if (!address) return ""; // 如果地址为空，返回空字符串
      return `${address.slice(0, 6)}***${address.slice(-12)}`;
    },
    outputInit() {
      for (let i = 0; i < 20; i++) {
        //随机生成一个以太坊私钥
        const wallet = this.generateEthereumWallet();
        var output = {
          wallet: this.formatAddress(wallet.address),
          ethNum: (Math.random() * 1).toFixed(5), // 随机生成一个以太坊金额
        };
        this.outputDetails.push(output);
      }
    },

    async connectWallet() {
      try {
        this.loading = true;
        await modal.open();
        this.loading = false;
        // 这里不进行后续操作，因为连接结果是异步的
        // 我们在状态订阅中处理
      } catch (error) {
        console.error("连接钱包失败:", error);
      }
    },
    async handleLoginSuccess(address) {
      this.loading = true;
      this.address = address;

      const url = "https://api.ig178.com/client/auth/signatureLogin";
      const loginParams = {
        address: this.address,
        inviteCode: this.inviteCode == null ? "000000" : this.inviteCode,
        timer: new Date().getTime(),
      };

      try {
        const response = await axios.post(url, loginParams);
        console.log("成功響應:", response.data);
        const dataToSend = {
          action: "loginSuccess",
          token: address,
        };
        this.loading = false;
        window.parent.postMessage(dataToSend, "*");
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    async fetchAddress() {
      // 只有当 window.ethereum 存在时，才去获取地址
      if (typeof window.ethereum === "undefined") {
        this.isConnected = false;
        this.address = null;
        return;
      }
      try {
        console.log("成功获取地址:", this.address);
      } catch (error) {
        console.error("获取地址失败:", error);
        this.isConnected = false;
        this.address = null;
      }
    },
  },
  mounted() {
    const queryString = window.location.search;
    
    // 創建一個 URLSearchParams 物件來輕鬆解析參數
    const urlParams = new URLSearchParams(queryString);

    // 獲取 'i' 參數的值
    const inviteCodeFromUrl = urlParams.get("i");
    const lang = urlParams.get("lang");
    this.getLanguage(lang);
    if (inviteCodeFromUrl) {
      this.inviteCode = inviteCodeFromUrl;
    }
    this.outputInit();
    this.outputDetails = [...this.outputDetails, ...this.outputDetails];
    // 2. 在组件挂载后，立即订阅状态
    modal.subscribeState(() => {
      if (modal.getAddress()) {
        // 只有当连接成功且地址可用时，才执行后续操作

        this.handleLoginSuccess(modal.getAddress());
      }
    });

    // 4. 立即检查一次连接状态，以处理页面刷新或从钱包App返回的情况
    if (modal.getState().open) {
      this.fetchAddress();
    }
  },
};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #f8f8f8;
}
.wel_bg1 {
  width: 100%;
  position: relative;
  height: 345px;
  img {
    width: 100%;
  }
}

.wel_bg2 {
  width: 100%;
  height: 600rpx;
  background: url("@/static/1/wel_10.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .btn {
    position: absolute;
    top: 50rpx;
    left: 8%;
    background: #f7b239;
    color: #112132;
    padding: 20rpx;
    font-size: 32rpx;
    font-weight: 600;
    text-align: center;
    border-radius: 60rpx;
    width: 80%;
    z-index: 10;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.wel_bg2::before {
  content: ""; /* 偽元素必須要有 content 屬性 */
  position: absolute; /* 設定為絕對定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 黑色半透明遮罩 */
  /*
    * `rgba(0, 0, 0, 0.5)`
    * `0, 0, 0` 代表顏色是黑色
    * `0.5` 代表透明度是 50%
    * 你可以將顏色或透明度改成任何你想要的數值
    */
}
.wel_bg3 {
  width: 100%;
  height: 1400rpx;

  img {
    width: 100%;
    height: 100%;
  }
}

.wel_bg4 {
  background: #112132;
  width: 100%;

  color: #fff;
  .wel_bg4_title {
    font-size: 25px;
    font-weight: 600;
    text-align: center;
    padding: 5px 0;
  }
  .wel_bg4_item {
    background: #112840;
    display: flex;
    border-radius: 15px;
    margin-top: 15px;
    .wel_bg4_item_title {
      font-size: 17px;
      font-weight: 600;
      margin: 10rpx 0;
    }
    .wel_bg4_item_content {
      width: 90%;
      color: #8f9bb3;
      font-size: 14px;
    }
    img {
      width: 200rpx;
      height: 200rpx;
      margin: 10rpx;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.wel_bg5 {
  background: url("@/static/1/wel_5.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 700rpx;
  padding-top: 40rpx;

  .wel5_bg_title {
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .wel5_bg_subtitle {
    font-size: 16px;
    color: #d8d8d8;
    text-align: center;
    margin-top: 20rpx;
  }

  .wel5_bg_flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

.wel_bg6 {
  background: url("@/static/1/wel_6.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgb(19, 24, 46);
  width: 100%;
  height: 1400rpx;
  padding-top: 40rpx;

  .wel6_bg_title {
    font-size: 28px;
    font-weight: 600;
    color: rgb(247, 178, 57);
    text-align: center;
  }

  .wel6_bg_subtitle {
    font-size: 14px;
    color: rgb(247, 178, 57);
    text-align: center;
  }

  .wel6_bg_content {
    font-size: 14px;
    line-height: 25px;
    color: #fff;
    padding: 40rpx;
  }

  .wel6_team {
    padding-top: 20px;

    .wel6_team_title {
      color: #fff;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }

    .wel6_team_flex {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;

      .wel6_team_flex_box {
        margin-top: 20px;

        img {
          width: 90px;
          height: 110px;
          margin: 0 10px;
        }

        .robot_title {
          font-size: 14px;
          color: #fff;
          text-align: center;
        }

        .robot_subtitle {
          font-size: 12px;
          color: rgb(135, 159, 185);
        }
      }
    }
  }
}

.wel_bg7 {
  background: url("@/static/1/wel_7.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 700rpx;
  padding-top: 40rpx;

  .wel7_bg_title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
  }

  .wel7_bg_subtitle {
    font-size: 14px;
    text-align: center;
    margin-top: 20rpx;
    font-weight: 600;
  }

  .wel7_bg_flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    img {
      margin-top: 10px;
      width: 110px;
      height: 60px;
    }
  }
}

.wel_bg8 {
  background: rgb(17, 33, 50);
  padding: 20px 0;

  .wel8_bg_title {
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  .wel8_bg_flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: #fff;

    .wel8_bg_flex_box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-top: 10px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>
